import { render, staticRenderFns } from "./general-form.vue?vue&type=template&id=6dd2e3aa"
import script from "./general-form.vue?vue&type=script&lang=js"
export * from "./general-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports